export default __webpack_public_path__ + "static/media/blogcard2.9de14c2d.png";